export default __webpack_public_path__ + "static/media/ic_tanzania.a7a5ca85.svg";